import isInteger from "lodash/isInteger";

function isValidNumberField(min, max) {
  return !isInteger(min) || !isInteger(max) || min <= max;
}

export default isValidNumberField;
